import ReactGA from 'react-ga4';
import Clarity from '@microsoft/clarity';
import { captureException } from '@sentry/react';

const trackActivity = (category, action, additionalData = {}) => {
    try {
        ReactGA.event({
            category,
            action,
            ...additionalData,
        });
    } catch (err) {
        captureException(err);
    }

    try {
        Clarity.event(`${category}_${action}`, additionalData);
    } catch (err) {
        captureException(err);
    }
};

export default trackActivity;
